const percentFormatterNDecimals = (val, nDecimals = 4) => {
  const value = parseFloat(val || 0);
  const roundedValue = value.toFixed(nDecimals);
  const percent = new Intl.NumberFormat('default', {
    style: 'percent',
    minimumFractionDigits: nDecimals,
    maximumFractionDigits: nDecimals,
  });
  const output = percent.format(parseFloat(roundedValue) / 100);
  return output;
};

export default percentFormatterNDecimals;
